import ButtonBase from "@mui/material/ButtonBase"
import Typography from "@mui/material/Typography"
import PropTypes from "prop-types"

import Row from "../../../common/components/Row"
import { statusMeta } from "./meetingUtils"

export const LEGEND_STATUSES = [
  "upcoming",
  "completed",
  "rescheduled",
  "cancelled",
]

// Colour key for the calendar. Each entry also filters: click to show only that
// status, click again to show everything.
export default function MeetingStatusLegend({ selected, onSelect }) {
  return (
    <Row
      role="group"
      aria-label="Meeting status colours"
      sx={{ gap: 0.75, flexWrap: "wrap", alignItems: "center" }}
    >
      {LEGEND_STATUSES.map((status) => {
        const { label, chip, calendarColor } = statusMeta(status)
        const isSelected = selected === status
        return (
          <ButtonBase
            key={status}
            aria-pressed={isSelected}
            title={
              isSelected ? "Show all statuses" : `Show only ${label} meetings`
            }
            onClick={() => onSelect(isSelected ? "" : status)}
            sx={{
              gap: 0.75,
              px: 1.25,
              py: 0.5,
              borderRadius: 999,
              border: "1px solid",
              borderColor: isSelected ? calendarColor : "transparent",
              backgroundColor: isSelected ? chip.background : "transparent",
              "&:hover": { backgroundColor: chip.background },
            }}
          >
            <span
              aria-hidden="true"
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: calendarColor,
              }}
            />
            <Typography
              variant="body2"
              sx={{ fontWeight: isSelected ? 700 : 500, color: chip.text }}
            >
              {label}
            </Typography>
          </ButtonBase>
        )
      })}
    </Row>
  )
}

MeetingStatusLegend.propTypes = {
  selected: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
}
